/**
 * DiffTable — field-level differences (path / model value / corrected value),
 * used by promote confirmation, correction records, eval scorecards, and
 * verifier disagreements. Rows accept:
 *   { path, model|actual, corrected|expected, tags? }
 */
import React from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Tag,
  Wrap,
  WrapItem,
  useColorModeValue,
} from '@chakra-ui/react';

const show = (v) => {
  if (v === null || v === undefined) return <Text as="span" color="gray.400">∅ null</Text>;
  if (v === '') return <Text as="span" color="gray.400">'' empty</Text>;
  return String(v);
};

export default function DiffTable({ rows = [], leftLabel = 'Model', rightLabel = 'Corrected' }) {
  const monoColor = useColorModeValue('gray.700', 'gray.300');
  if (!rows.length) {
    return (
      <Text fontSize="sm" color="gray.500">
        No differences.
      </Text>
    );
  }
  return (
    <Table size="sm" variant="simple">
      <Thead>
        <Tr>
          <Th>Field</Th>
          <Th>{leftLabel}</Th>
          <Th>{rightLabel}</Th>
          <Th>Tags</Th>
        </Tr>
      </Thead>
      <Tbody>
        {rows.map((d, i) => (
          <Tr key={`${d.path}-${i}`}>
            <Td fontFamily="mono" fontSize="xs" color={monoColor}>
              {d.path}
            </Td>
            <Td fontSize="xs" color="red.400">
              {show(d.model ?? d.actual)}
            </Td>
            <Td fontSize="xs" color="green.500" fontWeight="medium">
              {show(d.corrected ?? d.expected)}
            </Td>
            <Td>
              <Wrap spacing={1}>
                {(d.tags || []).map((t) => (
                  <WrapItem key={t}>
                    <Tag size="sm" variant="subtle" colorScheme="gray" fontSize="10px">
                      {t}
                    </Tag>
                  </WrapItem>
                ))}
              </Wrap>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
}
